import styled from 'styled-components';

const MyCarsContentWrapper = styled.div`
  margin: 0 auto;
  width: 100%;
`;

const MakePaymentWrapper = styled.div`
  align-content: center;
  background-color: ${(props) => props.theme.color.neutral.v200};
  box-shadow: rgb(24 53 88 / 10%) 1px 2px 3px 1px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-family: 'Brandon Text';
  margin: 0 auto;
  padding: 10px 24px 46px;
  max-width: 1800px;

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    padding: 10px 32px 46px;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.lg}px) {
    padding-bottom: 40px;
  }
`;

const SpinnerWrapper = styled.div`
  display: flex;
  min-height: 500px;
`;

export { MyCarsContentWrapper, MakePaymentWrapper, SpinnerWrapper };
